<template>
    <div class='jc-container-chart' >
        <jcb-monitor-chart
            ref='monitorChart'
            :params='monitorParams'
            :enable-full-chart='enableFullChart'
            :update-options='updateOptions'
            :enableSwitchAggregates ='enableFullChart'
            @error='onError'
        />
    </div>
</template>

<script>
export default {
    name: 'SingleMoitorChart',
    props: {
        serviceCode: {
            type: String,
            default: ''
        },
        groupCode: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        initialTitle: {
            type: String,
            default: ''
        },
        resourceId: {
            type: String,
            default: ''
        },
        regionId: {
            type: String,
            default: ''
        },
        timeInterval: {
            type: String,
            default: ''
        },
        metric: {
            type: Array,
            default:[]
        },
        startTime: {
            type: String,
            default: ''
        },
        endTime: {
            type: String,
            default: ''
        },
        selectChange: {
            type: Number,
            default: 1
        },
        changeDisk: {
            type: Object,
            default: {}
        },
        changeMountpoint: {
            type: Object,
            default: {}
        },
        changeNic: {
            type: Object,
            default: {}
        },
        updateSign: {
            type: Number,
            default: 0
        },
        nicChange: {
            type: String,
            default: ''
        },
        mountpointChange: {
            type: String,
            default: ''
        },

    },
    data() {
        return {
            daysArray: ['3d', '7d', '14d'], // 参数为“天”的集合，不包括1d
            updateOptions: (oOptions) => {
                const that = this;
                if (oOptions && oOptions.yAxis && oOptions.yAxis.axisPointer) {
                    oOptions.yAxis.axisPointer.show = false; // 不展示图标鼠标滑入的Y轴单位展示框
                }
                oOptions.xAxis.axisLabel ={
                    inside: false,
                    show: true,
                    formatter: function(value) {
                        try {
                            // 查询天数，横轴展示为 07-08 2025
                            if (that.daysArray.includes(that.timeInterval)) {
                                // 使用原生JavaScript格式化
                                // const date = new Date(value);
                                // const month = (date.getMonth() + 1).toString().padStart(2, '0');
                                // const day = date.getDate().toString().padStart(2, '0');
                                // const year = date.getFullYear();
                                // return `${month}-${day}\n${year}`;
                                let date = new Date(value);
                                let month = date.getMonth() + 1;
                                let day = date.getDate();
                                let year = date.getFullYear();
                                month = month < 10 ? '0' + month : month;
                                day = day < 10 ? '0' + day : day;
                                return `${month}-${day}\n${year}`;
                            // 查询小时，横轴展示为 12:00 07-08
                            } else {
                                // 原生JavaScript实现
                                // const date = new Date(value);
                                // const hours = date.getHours().toString().padStart(2, '0');
                                // const minutes = date.getMinutes().toString().padStart(2, '0');
                                // const month = (date.getMonth() + 1).toString().padStart(2, '0');
                                // const day = date.getDate().toString().padStart(2, '0');
                                // return `${hours}:${minutes}\n${month}-${day}`;
                                let date = new Date(value);
                                let hours = date.getHours();
                                let minutes = date.getMinutes();
                                let month = date.getMonth() + 1;
                                let day = date.getDate();
                                // 添加前导零
                                hours = hours < 10 ? '0' + hours : hours;
                                minutes = minutes < 10 ? '0' + minutes : minutes;
                                month = month < 10 ? '0' + month : month;
                                day = day < 10 ? '0' + day : day;
                                return `${hours}:${minutes}\n${month}-${day}`;
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }
                return oOptions;
            },
            enableFullChart: true,
            realTitle:'',
            monitorParams: {
                serviceCode: this.serviceCode,
                groupCode: this.groupCode,
                resourceId: this.resourceId,
                metric: this.metric,
                regionId: this.regionId,
                timeInterval: this.timeInterval,
                startTime: this.startTime,
                endTime:this.endTime,
                extra:{},
                title:this.title

            }
        };
    },
    created() {
        if(Object.keys(this.changeDisk).length) {
            this.monitorParams.extra = this.changeDisk
        }
        if(Object.keys(this.changeMountpoint).length) {
            this.monitorParams.extra = this.changeMountpoint
        }
        if(Object.keys(this.changeNic).length) {
            this.monitorParams.extra = this.changeNic
        }

    },
    watch: {
        selectChange() {
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        },
        startTime() {
            this.monitorParams.timeInterval = ''
            this.monitorParams.startTime = this.startTime,
            this.monitorParams.endTime = this.endTime,
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        },
        timeInterval(val) {
            this.monitorParams.timeInterval= this.timeInterval
            this.monitorParams.startTime = '',
            this.monitorParams.endTime = '',
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
            if(val==='') {
                this.monitorParams.startTime = this.startTime;
                this.monitorParams.endTime = this.endTime
            }

        },
        changeDisk() {
            this.monitorParams.extra = this.changeDisk,
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        },
        changeMountpoint() {
            this.monitorParams.extra = this.changeMountpoint;
            if(this.mountpointChange) {
                this.monitorParams.title = '(' + this.mountpointChange + ')' + this.initialTitle
            } else {
                this.monitorParams.title = this.initialTitle
            }

            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        },
        changeNic() {
            this.monitorParams.extra = this.changeNic;
            if(this.nicChange) {
                this.monitorParams.title = '(' + this.nicChange + ')' + this.initialTitle
            } else {
                this.monitorParams.title = this.initialTitle
            }
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        },
        updateSign() {
            this.$refs.monitorChart.update()
            this.$refs.monitorChart.resize()
        }
    },
    methods: {
        onError(error) {
            console.log(error)
        },
    }
}
</script>

<style lang="scss" scoped>
 .jc-container-chart {
    float: left;
    width: 395px;
    margin: 10px;
 }
</style>




// WEBPACK FOOTER //
// src/components/common/PerformanceMonitor/SingleMonitorChart.vue